import { render } from "./DataTables.vue?vue&type=template&id=93199a64&scoped=true"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"

import "./DataTables.vue?vue&type=style&index=0&id=93199a64&scoped=true&lang=css"

import exportComponent from "/Users/tandongling/Documents/vue/vue-argon-dashboard-2-pro-v3.0.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93199a64"]])

export default __exports__